import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import Utility from '../../../../Utility/Utility';
import { createDmcLead, createDmcNote } from '../Controller/HomeController';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import '../Assets/css/quotation-request-modal.scss';
import {
    Plane,
    CarFront,
    User,
    Mail,
    Phone,
    MapPin,
    Calendar,
    Clock,
    Users,
    CheckCircle,
    AlertCircle,
    Send,
    ShieldCheck,
    Tag,
    Zap,
    TrainFront,
    Compass
} from 'lucide-react';

const AIRPORT_CITIES = [
    // East India
    "Kolkata (CCU)",
    "Bhubaneswar (BBI)",
    "Patna (PAT)",
    "Gaya (GAY)",
    "Ranchi (IXR)",
    "Jamshedpur (IXW)",
    "Durgapur (RDP)",
    "Darbhanga (DBR)",
    "Deoghar (DGH)",
    "Bagdogra / Siliguri (IXB)",
    "Pakyong / Gangtok (PYG)",

    // North India
    "New Delhi (DEL)",
    "Chandigarh (IXC)",
    "Amritsar (ATQ)",
    "Lucknow (LKO)",
    "Varanasi (VNS)",
    "Prayagraj (IXD)",
    "Ayodhya (AYJ)",
    "Agra (AGR)",
    "Kanpur (KNU)",
    "Gorakhpur (GOP)",
    "Bareilly (BEK)",
    "Dehradun (DED)",
    "Pantnagar (PGH)",
    "Jammu (IXJ)",
    "Srinagar (SXR)",
    "Leh (IXL)",
    "Dharamshala (DHM)",
    "Shimla (SLV)",
    "Kullu / Manali (KUU)",
    "Jaipur (JAI)",
    "Jodhpur (JDH)",
    "Udaipur (UDR)",
    "Kishangarh / Ajmer (KQH)",
    "Bikaner (BKB)",
    "Jaisalmer (JSA)",
    "Hindon / Ghaziabad (HDO)",

    // West India
    "Mumbai (BOM)",
    "Pune (PNQ)",
    "Nagpur (NAG)",
    "Nashik (ISK)",
    "Shirdi (SAG)",
    "Kolhapur (KLH)",
    "Jalgaon (JLG)",
    "Chhatrapati Sambhajinagar (IXU)",
    "Goa - Dabolim (GOI)",
    "Goa - Mopa (GOX)",
    "Ahmedabad (AMD)",
    "Vadodara (BDQ)",
    "Surat (STV)",
    "Rajkot (HSR)",
    "Bhavnagar (BHU)",
    "Bhuj (BHJ)",
    "Kandla (IXY)",
    "Porbandar (PBD)",
    "Diu (DIU)",

    // South India
    "Bengaluru (BLR)",
    "Mysuru (MYQ)",
    "Mangaluru (IXE)",
    "Hubballi (HBX)",
    "Belagavi (IXG)",
    "Kalaburagi (GBI)",
    "Hyderabad (HYD)",
    "Chennai (MAA)",
    "Coimbatore (CJB)",
    "Madurai (IXM)",
    "Tiruchirappalli (TRZ)",
    "Salem (SXV)",
    "Thoothukudi (TCR)",
    "Kochi (COK)",
    "Thiruvananthapuram (TRV)",
    "Kozhikode (CCJ)",
    "Kannur (CNN)",
    "Vijayawada (VGA)",
    "Visakhapatnam (VTZ)",
    "Tirupati (TIR)",
    "Rajahmundry (RJA)",
    "Kadapa (CDP)",
    "Kurnool (KJB)",
    "Pondicherry (PNY)",

    // Central India
    "Bhopal (BHO)",
    "Indore (IDR)",
    "Jabalpur (JLR)",
    "Gwalior (GWL)",
    "Khajuraho (HJR)",
    "Rewa (REW)",
    "Bilaspur (PAB)",
    "Raipur (RPR)",
    "Jagdalpur (JGB)",
    "Udaipur / Dharamjaigarh (verify code before use)",

    // Northeast India
    "Guwahati (GAU)",
    "Dibrugarh (DIB)",
    "Jorhat (JRH)",
    "Silchar (IXS)",
    "Tezpur (TEZ)",
    "Lilabari / North Lakhimpur (IXI)",
    "Dimapur (DMU)",
    "Imphal (IMF)",
    "Agartala (IXA)",
    "Shillong (SHL)",
    "Aizawl (AJL)",
    "Lengpui (AJL)",
    "Kohima / Nagaland (check nearest operating airport)",
    "Itanagar / Hollongi (HGI)",
    "Pasighat (IXT)",
    "Ziro (ZER)",
    "Tura (no regular commercial airport code listing)",
    "Kushinagar (KBK)"
];

const CAB_TYPES = [
    { label: "Any / Best Available", value: "any" },

    // Budget & Small Cars
    { label: "Hatchback (WagonR, Swift, Tiago - 4 Seater)", value: "hatchback" },
    { label: "Compact Sedan (Dzire, Aura, Tigor - 4 Seater)", value: "compact_sedan" },
    { label: "Sedan (Honda Amaze, Etios - 4 Seater)", value: "sedan" },

    // SUV & Family Cars
    { label: "Compact SUV (Brezza, Nexon, Venue - 4/5 Seater)", value: "compact_suv" },
    { label: "SUV / MUV (Ertiga, Rumion, Triber - 6/7 Seater)", value: "suv" },
    { label: "Premium SUV / MUV (Innova, Crysta, Hycross - 7/8 Seater)", value: "premium_suv" },
    { label: "Full-Size SUV (Scorpio, XUV700, Safari - 6/7 Seater)", value: "full_size_suv" },
    { label: "Luxury SUV (Fortuner, Gloster - 7 Seater)", value: "luxury_suv" },

    // Premium & Luxury Cars
    { label: "Premium Sedan (Camry, Superb - 4 Seater)", value: "premium_sedan" },
    { label: "Luxury / Executive Car (Mercedes-Benz, BMW, Audi)", value: "luxury" },
    { label: "Luxury Van (Kia Carnival or Similar)", value: "luxury_van" },

    // Group Travel
    { label: "Tempo Traveller (9-12 Seater)", value: "tempo_9_12" },
    { label: "Tempo Traveller (13-17 Seater)", value: "tempo_13_17" },
    { label: "Force Urbania (10-17 Seater)", value: "urbania" },
    { label: "Mini Bus (18-27 Seater)", value: "mini_bus" },
    { label: "Bus (28-35 Seater)", value: "bus_28_35" },
    { label: "Large Bus (36-50 Seater)", value: "bus_36_50" }
];

const TIME_SLOTS = [
    "05:00 AM", "06:00 AM", "07:00 AM", "08:00 AM", "09:00 AM", "10:00 AM",
    "11:00 AM", "12:00 PM", "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM",
    "05:00 PM", "06:00 PM", "07:00 PM", "08:00 PM", "09:00 PM", "10:00 PM", "11:00 PM"
];

const TRAVEL_CLASS_OPTIONS = [
    { label: "Economy", value: "Economy" },
    { label: "Premium Economy", value: "Premium Economy" },
    { label: "Business", value: "Business" },
    { label: "First Class", value: "First Class" }
];

const TIME_SLOT_OPTIONS = TIME_SLOTS.map(t => ({
    label: t,
    value: t
}));

const CAB_TYPE_OPTIONS = CAB_TYPES.map(c => ({
    label: c.label,
    value: c.label
}));

const RENTAL_PACKAGE_OPTIONS = [
    { label: "4 Hours / 40 KM", value: "4 Hours / 40 KM" },
    { label: "8 Hours / 80 KM (Full Day)", value: "8 Hours / 80 KM" },
    { label: "12 Hours / 120 KM", value: "12 Hours / 120 KM" },
    { label: "Full Day Outstation Package", value: "Full Day Outstation Package" }
];

const RAILWAY_STATIONS = [
    // West Bengal & East India
    "Howrah Jn (HWH)",
    "Sealdah (SDAH)",
    "Kolkata Shalimar (SHM)",
    "Kolkata Terminal (KOAA)",
    "New Jalpaiguri / Siliguri (NJP)",
    "Siliguri Jn (SGUJ)",
    "Asansol Jn (ASN)",
    "Durgapur (DGR)",
    "Kharagpur Jn (KGP)",
    "Malda Town (MLDT)",
    "Barddhaman Jn (BWN)",
    "Patna Jn (PNBE)",
    "Rajendra Nagar (RJPB)",
    "Gaya Jn (GAYA)",
    "Muzaffarpur Jn (MFP)",
    "Darbhanga Jn (DBG)",
    "Ranchi Jn (RNC)",
    "Dhanbad Jn (DHN)",
    "Tatanagar / Jamshedpur (TATA)",
    "Bhubaneswar (BBS)",
    "Puri (PURI)",
    "Cuttack (CTC)",
    "Rourkela (ROU)",

    // North India & Delhi NCR
    "New Delhi (NDLS)",
    "Delhi Anand Vihar (ANVT)",
    "Hazrat Nizamuddin (NZM)",
    "Old Delhi (DLI)",
    "Delhi Sarai Rohilla (DEE)",
    "Lucknow Charbagh (LKO)",
    "Lucknow Jn (LJN)",
    "Kanpur Central (CNB)",
    "Varanasi Jn (BSB)",
    "Banaras (BSBS)",
    "Prayagraj Jn (PRYJ)",
    "Ayodhya Dham (AY)",
    "Ayodhya Cantt (AYC)",
    "Agra Cantt (AGC)",
    "Gorakhpur Jn (GKP)",
    "Mathura Jn (MTJ)",
    "Bareilly Jn (BE)",
    "Haridwar (HW)",
    "Dehradun (DDN)",
    "Rishikesh (YNRK)",
    "Chandigarh (CDG)",
    "Amritsar Jn (ASR)",
    "Ludhiana Jn (LDH)",
    "Kalka (KLK)",
    "Jammu Tawi (JAT)",
    "SMVD Katra (SVDK)",
    "Jaipur Jn (JP)",
    "Jodhpur Jn (JU)",
    "Udaipur City (UDZ)",
    "Ajmer Jn (AII)",
    "Kota Jn (KOTA)",
    "Bikaner Jn (BKN)",
    "Jaisalmer (JSM)",

    // West India
    "Mumbai CSMT (CSMT)",
    "Mumbai Central (MMCT)",
    "Bandra Terminus (BDTS)",
    "Lokmanya Tilak Terminus (LTT)",
    "Dadar (DR)",
    "Thane (TNA)",
    "Kalyan Jn (KYN)",
    "Pune Jn (PUNE)",
    "Nagpur Jn (NGP)",
    "Nashik Road (NK)",
    "Chhatrapati Sambhajinagar (AWB)",
    "Ahmedabad Jn (ADI)",
    "Surat (ST)",
    "Vadodara Jn (BRC)",
    "Rajkot Jn (RJT)",
    "Bhavnagar (BVC)",
    "Madgaon Goa (MAO)",
    "Vasco Da Gama (VSG)",
    "Karmali (KRMI)",

    // South India
    "KSR Bengaluru (SBC)",
    "Yesvantpur Jn (YPR)",
    "SMVT Bengaluru (SMVB)",
    "Mysuru Jn (MYS)",
    "Mangaluru Central (MAQ)",
    "Chennai Central (MAS)",
    "Chennai Egmore (MS)",
    "Tambaram (TBM)",
    "Coimbatore Jn (CBE)",
    "Madurai Jn (MDU)",
    "Tiruchirappalli Jn (TPJ)",
    "Salem Jn (SA)",
    "Ernakulam Jn / South (ERS)",
    "Ernakulam Town / North (ERN)",
    "Thiruvananthapuram Central (TVC)",
    "Kozhikode (CLT)",
    "Secunderabad Jn (SC)",
    "Hyderabad Deccan (HYB)",
    "Kacheguda (KCG)",
    "Visakhapatnam (VSKP)",
    "Vijayawada Jn (BZA)",
    "Tirupati (TPTY)",

    // Central & Northeast India
    "Bhopal Jn (BPL)",
    "Rani Kamlapati (RKMP)",
    "Indore Jn (INDB)",
    "Gwalior Jn (GWL)",
    "Jabalpur (JBP)",
    "Ujjain Jn (UJN)",
    "Raipur Jn (R)",
    "Bilaspur Jn (BSP)",
    "Guwahati (GHY)",
    "Kamakhya (KYQ)",
    "Dibrugarh (DBRG)"
];

const TRAIN_CLASS_OPTIONS = [
    { label: "All Classes / Any", value: "All Classes" },
    { label: "AC 1st Class (1A)", value: "AC 1st Class (1A)" },
    { label: "AC 2 Tier (2A)", value: "AC 2 Tier (2A)" },
    { label: "AC 3 Tier (3A)", value: "AC 3 Tier (3A)" },
    { label: "AC 3 Economy (3E)", value: "AC 3 Economy (3E)" },
    { label: "AC Chair Car (CC)", value: "AC Chair Car (CC)" },
    { label: "Exec. Chair Car (EC)", value: "Exec. Chair Car (EC)" },
    { label: "Vande Bharat / Tejas (CC/EC)", value: "Vande Bharat (CC/EC)" },
    { label: "Sleeper (SL)", value: "Sleeper (SL)" },
    { label: "Second Sitting (2S)", value: "Second Sitting (2S)" }
];

const TRAIN_QUOTA_OPTIONS = [
    { label: "General Quota (GN)", value: "General" },
    { label: "Tatkal Quota (CK)", value: "Tatkal" },
    { label: "Premium Tatkal (PT)", value: "Premium Tatkal" },
    { label: "Ladies Quota (LD)", value: "Ladies" },
    { label: "Senior Citizen (SS)", value: "Senior Citizen" }
];

const QuotationRequestModal = ({
    show,
    onHide,
    initialServiceType = 'flight',
    serviceCategory
}) => {
    const todayStr = moment().format('YYYY-MM-DD');
    const tomorrowStr = moment().add(1, 'days').format('YYYY-MM-DD');

    // Grouping: 'flight_train' contains flight & train inquiries, 'cabs' contains only cab inquiry
    const activeCategory = serviceCategory || (initialServiceType === 'cabs' ? 'cabs' : initialServiceType === 'customized_tour' ? 'customized_tour' : 'flight_train');
    const isFlightOrTrainGroup = activeCategory === 'flight_train';
    const isCustomizedTourGroup = activeCategory === 'customized_tour';

    const getInitialService = () => {
        if (isFlightOrTrainGroup) {
            return initialServiceType === 'train' ? 'train' : 'flight';
        }
        return isCustomizedTourGroup ? 'customized_tour' : 'cabs';
    };

    const [serviceType, setServiceType] = useState(getInitialService());
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [submitSummary, setSubmitSummary] = useState(null);

    // Contact Details
    const [contact, setContact] = useState({
        fullName: '',
        email: '',
        phone: '',
        city: ''
    });

    // Flight Details
    const [flight, setFlight] = useState({
        tripType: 'oneway', // 'oneway' | 'roundtrip' | 'multicity'
        from: '',
        to: '',
        departureDate: todayStr,
        returnDate: tomorrowStr,
        adults: 1,
        children: 0,
        travelClass: 'Economy',
        preferredAirline: '',
        specialRequests: ''
    });

    // Train Details
    const [train, setTrain] = useState({
        tripType: 'oneway', // 'oneway' | 'roundtrip'
        from: '',
        to: '',
        departureDate: todayStr,
        returnDate: tomorrowStr,
        adults: 1,
        children: 0,
        travelClass: 'All Classes',
        quota: 'General',
        preferredTrain: '',
        specialRequests: ''
    });

    // Cab Details
    const [cab, setCab] = useState({
        tripType: 'outstation_round', // 'outstation_round' | 'outstation_oneway' | 'airport_transfer' | 'local_rental'
        pickupLocation: '',
        dropLocation: '',
        pickupDate: todayStr,
        pickupTime: '09:00 AM',
        returnDate: tomorrowStr,
        cabType: 'Sedan (Dzire, Etios, Amaze - 4 Seater)',
        passengers: 1,
        rentalPackage: '8 Hours / 80 KM',
        specialRequests: ''
    });

    // Customized Tour Details
    const [customTour, setCustomTour] = useState({
        destination: '',
        startDate: todayStr,
        endDate: tomorrowStr,
        adults: 1,
        children: 0,
        budget: '',
        specialRequests: ''
    });

    const [errors, setErrors] = useState({});

    // Reset or update service type when modal opens or initialServiceType changes
    useEffect(() => {
        if (show) {
            if (isFlightOrTrainGroup) {
                setServiceType(initialServiceType === 'train' ? 'train' : 'flight');
            } else {
                setServiceType(isCustomizedTourGroup ? 'customized_tour' : 'cabs');
            }
            setIsSubmitted(false);
            setErrors({});
        }
    }, [show, initialServiceType, isFlightOrTrainGroup, isCustomizedTourGroup]);

    // Handle Contact changes
    const handleContactChange = (field, value) => {
        setContact(prev => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    // Handle Flight changes
    const handleFlightChange = (field, value) => {
        setFlight(prev => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    // Handle Train changes
    const handleTrainChange = (field, value) => {
        setTrain(prev => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    // Handle Cab changes
    const handleCabChange = (field, value) => {
        setCab(prev => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    // Handle Customized Tour changes
    const handleCustomTourChange = (field, value) => {
        setCustomTour(prev => ({ ...prev, [field]: value }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: null }));
        }
    };

    // Block non-numeric characters on key down
    const handleNumericKeyDown = (e) => {
        if (e.ctrlKey || e.metaKey) return;
        if (['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(e.key)) {
            return;
        }
        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    };

    // Block non-numeric text on paste
    const handleNumericPaste = (e) => {
        const pasteData = e.clipboardData.getData('text');
        if (!/^\d+$/.test(pasteData)) {
            e.preventDefault();
        }
    };

    // Validate entire form
    const validateForm = () => {
        const newErrors = {};

        // 1. Contact Validations
        if (!contact.fullName || contact.fullName.trim().length < 2) {
            newErrors.fullName = "Please enter your full name (minimum 2 characters)";
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (contact.email && contact.email.trim() && !emailRegex.test(contact.email.trim())) {
            newErrors.email = "Please enter a valid email address";
        }

        const phoneDigits = contact.phone ? contact.phone.replace(/\D/g, '') : '';
        if (!phoneDigits || phoneDigits.length < 10) {
            newErrors.phone = "Please enter a valid 10-digit mobile number";
        }

        // 2. Service Specific Validations
        if (serviceType === 'flight') {
            if (!flight.from || flight.from.trim().length === 0) {
                newErrors.from = "Please enter departure city or airport";
            }
            if (!flight.to || flight.to.trim().length === 0) {
                newErrors.to = "Please enter destination city or airport";
            } else if (flight.from && flight.from.trim().toLowerCase() === flight.to.trim().toLowerCase()) {
                newErrors.to = "Destination cannot be identical to departure location";
            }

            if (!flight.departureDate) {
                newErrors.departureDate = "Please select departure date";
            } else if (moment(flight.departureDate).isBefore(moment(), 'day')) {
                newErrors.departureDate = "Departure date cannot be in the past";
            }

            if (flight.tripType === 'roundtrip') {
                if (!flight.returnDate) {
                    newErrors.returnDate = "Please select return date";
                } else if (moment(flight.returnDate).isBefore(moment(flight.departureDate), 'day')) {
                    newErrors.returnDate = "Return date cannot be before departure date";
                }
            }

            if (!flight.adults || Number(flight.adults) < 1) {
                newErrors.adults = "At least 1 adult passenger is required";
            }
        } else if (serviceType === 'train') {
            // Train Validations
            if (!train.from || train.from.trim().length === 0) {
                newErrors.from = "Please enter departure railway station or city";
            }
            if (!train.to || train.to.trim().length === 0) {
                newErrors.to = "Please enter destination railway station or city";
            } else if (train.from && train.from.trim().toLowerCase() === train.to.trim().toLowerCase()) {
                newErrors.to = "Destination cannot be identical to departure station";
            }

            if (!train.departureDate) {
                newErrors.departureDate = "Please select journey date";
            } else if (moment(train.departureDate).isBefore(moment(), 'day')) {
                newErrors.departureDate = "Journey date cannot be in the past";
            }

            if (train.tripType === 'roundtrip') {
                if (!train.returnDate) {
                    newErrors.returnDate = "Please select return date";
                } else if (moment(train.returnDate).isBefore(moment(train.departureDate), 'day')) {
                    newErrors.returnDate = "Return date cannot be before departure date";
                }
            }

            if (!train.adults || Number(train.adults) < 1) {
                newErrors.adults = "At least 1 adult passenger is required";
            }
        } else if (serviceType === 'customized_tour') {
            // Customized Tour Validations
            if (!customTour.destination || customTour.destination.trim().length === 0) {
                newErrors.destination = "Please enter your desired destination";
            }

            if (!customTour.startDate) {
                newErrors.startDate = "Please select travel start date";
            } else if (moment(customTour.startDate).isBefore(moment(), 'day')) {
                newErrors.startDate = "Start date cannot be in the past";
            }

            if (!customTour.endDate) {
                newErrors.endDate = "Please select travel end date";
            } else if (moment(customTour.endDate).isBefore(moment(customTour.startDate), 'day')) {
                newErrors.endDate = "End date cannot be before start date";
            }

            if (!customTour.adults || Number(customTour.adults) < 1) {
                newErrors.adults = "At least 1 adult traveler is required";
            }
        } else {
            // Cab Validations
            if (!cab.pickupLocation || cab.pickupLocation.trim().length === 0) {
                newErrors.pickupLocation = "Please enter pickup city or address";
            }

            if (cab.tripType !== 'local_rental') {
                if (!cab.dropLocation || cab.dropLocation.trim().length === 0) {
                    newErrors.dropLocation = "Please enter drop destination or city";
                }
            }

            if (!cab.pickupDate) {
                newErrors.pickupDate = "Please select pickup date";
            } else if (moment(cab.pickupDate).isBefore(moment(), 'day')) {
                newErrors.pickupDate = "Pickup date cannot be in the past";
            }

            if (!cab.pickupTime) {
                newErrors.pickupTime = "Please select pickup time";
            }

            if (cab.tripType === 'outstation_round') {
                if (!cab.returnDate) {
                    newErrors.returnDate = "Please select return date";
                } else if (moment(cab.returnDate).isBefore(moment(cab.pickupDate), 'day')) {
                    newErrors.returnDate = "Return date cannot be before pickup date";
                }
            }

            if (!cab.passengers || Number(cab.passengers) < 1) {
                newErrors.passengers = "At least 1 passenger is required";
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Submit Inquiry Request
    const handleSubmit = async (e) => {
        if (e) e.preventDefault();

        if (!validateForm()) {
            return;
        }

        setIsSubmitting(true);

        const cleanPhone = contact.phone.replace(/\D/g, '').slice(-10);
        let serviceLabel = 'Flight';
        if (serviceType === 'train') serviceLabel = 'Train';
        if (serviceType === 'cabs') serviceLabel = 'Cab';
        if (serviceType === 'customized_tour') serviceLabel = 'Customized Tour';

        // Prepare Summary Object for lead remarks
        let summaryText = {};
        let detailsJson = {};

        if (serviceType === 'flight') {
            const passSummary = `${flight.adults} Adults${flight.children > 0 ? `, ${flight.children} Children` : ''}`;
            summaryText = {
                trip: (flight.tripType || "").toUpperCase(),
                route: `${flight.from || ""} -> ${flight.to || ""}`,
                departureDate: flight.departureDate || "",
                ...(flight.tripType === 'roundtrip' ? { returnDate: flight.returnDate || "" } : {}),
                class: flight.travelClass || "",
                passengers: passSummary,
                ...(flight.preferredAirline ? { airline: flight.preferredAirline || "" } : {}),
                ...(flight.specialRequests ? { notes: flight.specialRequests || "" } : {})
            };
            detailsJson = {
                service_type: 'Flight',
                trip_type: flight.tripType || "",
                from: flight.from || "",
                to: flight.to || "",
                departure_date: flight.departureDate || "",
                return_date: flight.tripType === 'roundtrip' ? flight.returnDate : "",

                adults: flight.adults || 0,
                children: flight.children || 0,
                travel_class: flight.travelClass || "",
                preferred_airline: flight.preferredAirline || "",
                special_requests: flight.specialRequests || ""
            };
        } else if (serviceType === 'train') {
            const passSummary = `${train.adults} Adults${train.children > 0 ? `, ${train.children} Children` : ''}`;
            summaryText = {
                trip: (train.tripType || "").toUpperCase(),
                route: `${train.from || ""} -> ${train.to || ""}`,
                departureDate: train.departureDate || "",
                ...(train.tripType === 'roundtrip' ? { returnDate: train.returnDate || "" } : {}),
                class: train.travelClass || "",
                quota: train.quota || "General",
                passengers: passSummary,
                ...(train.preferredTrain ? { train: train.preferredTrain || "" } : {}),
                ...(train.specialRequests ? { notes: train.specialRequests || "" } : {})
            };
            detailsJson = {
                service_type: 'Train',
                trip_type: train.tripType || "",
                from: (train.from || "").trim(),
                to: (train.to || "").trim(),
                departure_date: train.departureDate || "",
                return_date: train.tripType === 'roundtrip' ? train.returnDate : "",
                adults: train.adults || 0,
                children: train.children || 0,
                travel_class: train.travelClass || "All Classes",
                quota: train.quota || "General",
                preferred_train: (train.preferredTrain || "").trim(),
                special_requests: (train.specialRequests || "").trim()
            };
        } else if (serviceType === 'customized_tour') {
            const passSummary = `${customTour.adults} Adults${customTour.children > 0 ? `, ${customTour.children} Children` : ''}`;
            summaryText = {
                destination: customTour.destination || "",
                travelDates: `${customTour.startDate} -> ${customTour.endDate}`,
                travelers: passSummary,
                ...(customTour.budget ? { budget: customTour.budget } : {}),
                ...(customTour.specialRequests ? { notes: customTour.specialRequests } : {})
            };
            detailsJson = {
                service_type: 'Customized Tour',
                destination: (customTour.destination || "").trim(),
                start_date: customTour.startDate || "",
                end_date: customTour.endDate || "",
                adults: customTour.adults || 0,
                children: customTour.children || 0,
                budget: (customTour.budget || "").trim(),
                special_requests: (customTour.specialRequests || "").trim()
            };
        } else {
            summaryText = {
                trip: (cab.tripType || "").toUpperCase(),
                pickup: cab.pickupLocation || "",
                drop: cab.dropLocation || 'Local Rental',
                date: `${cab.pickupDate} at ${cab.pickupTime}`,
                ...(cab.tripType === 'outstation_round' ? { returnDate: cab.returnDate } : {}),
                vehicle: cab.cabType || "",
                adults: cab.passengers.adults || "",
                children: cab.passengers.children || "",
                ...(cab.tripType === 'local_rental' ? { package: cab.rentalPackage } : {}),
                ...(cab.specialRequests ? { notes: cab.specialRequests } : {})
            };
            detailsJson = {
                service_type: 'Cabs',
                trip_type: cab.tripType || "",
                pickup_location: (cab.pickupLocation || "").trim(),
                drop_location: (cab.dropLocation || "").trim(),
                pickup_date: cab.pickupDate || "",
                pickup_time: cab.pickupTime || "",
                return_date: cab.tripType === 'outstation_round' ? cab.returnDate : "",
                cab_type: (cab.cabType || "").trim(),
                adults: cab.passengers.adults || 0,
                children: cab.passengers.children || 0,
                rental_package: (cab.rentalPackage || "").trim(),
                special_requests: (cab.specialRequests || "").trim()
            };
        }

        const leadPayload = [{
            customer_name: (contact.fullName || "").trim(),
            customer_phone: cleanPhone || "",
            customer_email: (contact.email || '').trim(),
            source_id: "Marketplace",
            lead_priority: "medium",
            remarks: "",
            stage_id: 1,
            created_by: 0,
            content_json: detailsJson
        }];

        console.log("leadPayload: ", leadPayload);
        try {
            const leadResponse = await createDmcLead(leadPayload).catch((err) => {
                console.warn("createDmcLead network warning (continuing lead capture):", err);
                return null;
            });
            Utility.toastNotifications(
                `Thank you, ${contact.fullName}! Your ${serviceLabel} quotation request has been submitted successfully. Our travel desk will contact you shortly with the best fares.`,
                "Inquiry Request Received",
                "success"
            );
            resetForm();
            onHide();
        } catch (error) {
            console.error("Error submitting quotation request:", error);
            // Reassure user regardless of network hiccup so their submission is acknowledged
            Utility.toastNotifications(
                `Thank you, ${contact.fullName}! Your ${serviceLabel} quotation request has been recorded. Our team will contact you shortly.`,
                "Inquiry Request Received",
                "success"
            );
            resetForm();
            onHide();
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetForm = () => {
        setContact({
            fullName: '',
            email: '',
            phone: '',
            city: ''
        });
        setFlight({
            tripType: 'oneway',
            from: '',
            to: '',
            departureDate: todayStr,
            returnDate: tomorrowStr,
            adults: 1,
            children: 0,
            travelClass: 'Economy',
            preferredAirline: '',
            specialRequests: ''
        });
        setTrain({
            tripType: 'oneway',
            from: '',
            to: '',
            departureDate: todayStr,
            returnDate: tomorrowStr,
            adults: 1,
            children: 0,
            travelClass: 'All Classes',
            quota: 'General',
            preferredTrain: '',
            specialRequests: ''
        });
        setCab({
            tripType: 'outstation_round',
            pickupLocation: '',
            dropLocation: '',
            pickupDate: todayStr,
            pickupTime: '09:00 AM',
            returnDate: tomorrowStr,
            cabType: 'Sedan (Dzire, Etios, Amaze - 4 Seater)',
            passengers: 1,
            rentalPackage: '8 Hours / 80 KM',
            specialRequests: ''
        });
        setCustomTour({
            destination: '',
            startDate: todayStr,
            endDate: tomorrowStr,
            adults: 1,
            children: 0,
            budget: '',
            specialRequests: ''
        });
        setIsSubmitted(false);
        setErrors({});
    };

    const handleResetAndClose = () => {
        setIsSubmitted(false);
        setErrors({});
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleResetAndClose}
            className="quotation-request-modal fade"
            dialogClassName="quotation-request-modal-dialog"
            backdropClassName="quotation-request-backdrop"
            centered
            backdrop="static"
            keyboard={true}
            style={{ zIndex: 9999 }}
        >
            {/* Modal Header */}
            <div className="quotation-modal-header">
                <div className="header-top">
                    <div className="header-title-wrap">
                        <span className="badge-quote-desk">
                            <Zap size={12} /> Travel Inquiry Desk
                        </span>
                        {/* <h3>Request a Custom Inquiry</h3>
                        <p>Fill in your journey requirements and our travel specialists will curate the best available fares and options for you.</p> */}
                    </div>
                    <button
                        type="button"
                        className="btn-close-quote"
                        onClick={handleResetAndClose}
                        aria-label="Close modal"
                    >
                        ✕
                    </button>
                </div>

                {/* Service Type Switcher */}
                {!isSubmitted && (
                    <div className={`service-switch-tabs ${!isFlightOrTrainGroup ? 'single-tab' : ''}`} role="tablist">
                        {isFlightOrTrainGroup ? (
                            <>
                                <button
                                    type="button"
                                    className={`tab-btn ${serviceType === 'flight' ? 'active' : ''}`}
                                    onClick={() => {
                                        setServiceType('flight');
                                        setErrors({});
                                    }}
                                >
                                    <Plane className="tab-icon" size={17} />
                                    Flight Inquiry
                                </button>
                                <button
                                    type="button"
                                    className={`tab-btn ${serviceType === 'train' ? 'active' : ''}`}
                                    onClick={() => {
                                        setServiceType('train');
                                        setErrors({});
                                    }}
                                >
                                    <TrainFront className="tab-icon" size={17} />
                                    Train Inquiry
                                </button>
                            </>
                        ) : isCustomizedTourGroup ? (
                            <button
                                type="button"
                                className={`tab-btn ${serviceType === 'customized_tour' ? 'active' : ''}`}
                                onClick={() => {
                                    setServiceType('customized_tour');
                                    setErrors({});
                                }}
                            >
                                <Compass className="tab-icon" size={17} />
                                Customized Tour Inquiry
                            </button>
                        ) : (
                            <button
                                type="button"
                                className={`tab-btn ${serviceType === 'cabs' ? 'active' : ''}`}
                                onClick={() => {
                                    setServiceType('cabs');
                                    setErrors({});
                                }}
                            >
                                <CarFront className="tab-icon" size={17} />
                                Cab & Taxi Inquiry
                            </button>
                        )}
                    </div>
                )}
            </div>

            {/* Modal Body */}
            <div className="quotation-modal-body">
                {isSubmitted ? (
                    <div className="quote-success-view">
                        <div className="success-icon-wrap">
                            <CheckCircle size={44} />
                        </div>
                        <h4>Inquiry Request Received!</h4>
                        <p>
                            Thank you, <strong>{submitSummary?.name}</strong>. Our dedicated travel desk has received your {submitSummary?.service?.toLowerCase()} quotation request. We are searching the best deals and will share an official quotation on your phone{submitSummary?.email ? ' and email' : ''} within 30 minutes.
                        </p>

                        <div className="success-summary-box">
                            <div className="summary-row">
                                <span className="summary-label">Service Type:</span>
                                <span className="summary-val">{submitSummary?.service}</span>
                            </div>
                            <div className="summary-row">
                                <span className="summary-label">Contact Person:</span>
                                <span className="summary-val">{submitSummary?.name}</span>
                            </div>
                            <div className="summary-row">
                                <span className="summary-label">Mobile Number:</span>
                                <span className="summary-val">+91 {submitSummary?.phone}</span>
                            </div>
                            {submitSummary?.email ? (
                                <div className="summary-row">
                                    <span className="summary-label">Email:</span>
                                    <span className="summary-val">{submitSummary?.email}</span>
                                </div>
                            ) : null}
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                                background: '#75723d',
                                borderColor: '#75723d',
                                padding: '10px 28px',
                                fontWeight: 700,
                                borderRadius: 8
                            }}
                            onClick={handleResetAndClose}
                        >
                            Done & Back to Home
                        </button>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} noValidate>
                        {/* Overall validation summary if any errors exist */}
                        {Object.keys(errors).length > 0 && (
                            <div className="form-summary-alert">
                                <AlertCircle size={18} style={{ flexShrink: 0 }} />
                                <span>Please review and complete the highlighted required fields marked with *</span>
                            </div>
                        )}

                        {/* SECTION 1: Contact Details */}
                        <div className="section-card">
                            <div className="section-heading">
                                <div className="section-icon-badge">
                                    <User size={15} />
                                </div>
                                <span>1. Contact Information</span>
                                <span className="text-muted">* All quotes will be sent here</span>
                            </div>

                            <div className="row">
                                <div className="col-md-4 col-sm-6">
                                    <div className="form-group-custom">
                                        <label htmlFor="quote-fullname">
                                            Full Name <span className="required-star">*</span>
                                        </label>
                                        <div className="input-wrapper">
                                            <User className="input-icon" size={15} />
                                            <input
                                                id="quote-fullname"
                                                type="text"
                                                className={`with-icon ${errors.fullName ? 'has-error' : ''}`}
                                                placeholder="e.g. Rahul Sharma"
                                                value={contact.fullName}
                                                onChange={(e) => handleContactChange('fullName', e.target.value)}
                                            />
                                        </div>
                                        {errors.fullName && <span className="error-msg">{errors.fullName}</span>}
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-6">
                                    <div className="form-group-custom">
                                        <label htmlFor="quote-phone">
                                            Phone / Mobile <span className="required-star">*</span>
                                        </label>
                                        <div className="input-wrapper">
                                            <Phone className="input-icon" size={15} />
                                            <input
                                                id="quote-phone"
                                                type="tel"
                                                maxLength="10"
                                                className={`with-icon ${errors.phone ? 'has-error' : ''}`}
                                                placeholder="10-digit mobile number"
                                                value={contact.phone}
                                                onChange={(e) => handleContactChange('phone', e.target.value)}
                                            />
                                        </div>
                                        {errors.phone && <span className="error-msg">{errors.phone}</span>}
                                    </div>
                                </div>

                                <div className="col-md-4 col-sm-12">
                                    <div className="form-group-custom">
                                        <label htmlFor="quote-email">
                                            Email Address
                                        </label>
                                        <div className="input-wrapper">
                                            <Mail className="input-icon" size={15} />
                                            <input
                                                id="quote-email"
                                                type="email"
                                                className={`with-icon ${errors.email ? 'has-error' : ''}`}
                                                placeholder="e.g. rahul@example.com"
                                                value={contact.email}
                                                onChange={(e) => handleContactChange('email', e.target.value)}
                                            />
                                        </div>
                                        {errors.email && <span className="error-msg">{errors.email}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* SECTION 2: Service Booking Information */}
                        {serviceType === 'flight' ? (
                            /* FLIGHT BOOKING FORM */
                            <div className="section-card">
                                <div className="section-heading">
                                    <div className="section-icon-badge">
                                        <Plane size={15} />
                                    </div>
                                    <span>2. Flight Journey Details</span>
                                </div>

                                {/* Flight Trip Type */}
                                <div className="trip-type-selector">
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${flight.tripType === 'oneway' ? 'active' : ''}`}
                                        onClick={() => handleFlightChange('tripType', 'oneway')}
                                    >
                                        ✈️ One Way
                                    </button>
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${flight.tripType === 'roundtrip' ? 'active' : ''}`}
                                        onClick={() => handleFlightChange('tripType', 'roundtrip')}
                                    >
                                        🔁 Round Trip
                                    </button>
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${flight.tripType === 'multicity' ? 'active' : ''}`}
                                        onClick={() => handleFlightChange('tripType', 'multicity')}
                                    >
                                        🔀 Multi City
                                    </button>
                                </div>

                                {/* From and To */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-from">
                                                From (Departure City/Airport) <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <MapPin className="input-icon" size={15} />
                                                <input
                                                    id="flight-from"
                                                    type="text"
                                                    list="popular-flight-origins"
                                                    className={`with-icon ${errors.from ? 'has-error' : ''}`}
                                                    placeholder="e.g. Kolkata (CCU) or New Delhi (DEL)"
                                                    value={flight.from}
                                                    onChange={(e) => handleFlightChange('from', e.target.value)}
                                                />
                                                <datalist id="popular-flight-origins">
                                                    {AIRPORT_CITIES.map((c, i) => <option key={i} value={c} />)}
                                                </datalist>
                                            </div>
                                            {errors.from && <span className="error-msg">{errors.from}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-to">
                                                To (Destination City/Airport) <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <MapPin className="input-icon" size={15} />
                                                <input
                                                    id="flight-to"
                                                    type="text"
                                                    list="popular-flight-destinations"
                                                    className={`with-icon ${errors.to ? 'has-error' : ''}`}
                                                    placeholder="e.g. Mumbai (BOM) or Goa (GOI)"
                                                    value={flight.to}
                                                    onChange={(e) => handleFlightChange('to', e.target.value)}
                                                />
                                                <datalist id="popular-flight-destinations">
                                                    {AIRPORT_CITIES.map((c, i) => <option key={i} value={c} />)}
                                                </datalist>
                                            </div>
                                            {errors.to && <span className="error-msg">{errors.to}</span>}
                                        </div>
                                    </div>
                                </div>

                                {/* Dates */}
                                <div className="row">
                                    <div className={flight.tripType === 'roundtrip' ? "col-md-6 col-sm-6" : "col-md-12"}>
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-departure-date">
                                                Departure Date <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <Calendar className="input-icon" size={15} />
                                                <input
                                                    id="flight-departure-date"
                                                    type="date"
                                                    min={todayStr}
                                                    className={`with-icon ${errors.departureDate ? 'has-error' : ''}`}
                                                    value={flight.departureDate}
                                                    onChange={(e) => handleFlightChange('departureDate', e.target.value)}
                                                />
                                            </div>
                                            {errors.departureDate && <span className="error-msg">{errors.departureDate}</span>}
                                        </div>
                                    </div>

                                    {flight.tripType === 'roundtrip' && (
                                        <div className="col-md-6 col-sm-6">
                                            <div className="form-group-custom">
                                                <label htmlFor="flight-return-date">
                                                    Return Date <span className="required-star">*</span>
                                                </label>
                                                <div className="input-wrapper">
                                                    <Calendar className="input-icon" size={15} />
                                                    <input
                                                        id="flight-return-date"
                                                        type="date"
                                                        min={flight.departureDate || todayStr}
                                                        className={`with-icon ${errors.returnDate ? 'has-error' : ''}`}
                                                        value={flight.returnDate}
                                                        onChange={(e) => handleFlightChange('returnDate', e.target.value)}
                                                    />
                                                </div>
                                                {errors.returnDate && <span className="error-msg">{errors.returnDate}</span>}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Passengers & Travel Class */}
                                <div className="row">
                                    <div className="col-md-4 col-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-adults">
                                                Adults (12+ yrs) <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <input
                                                    id="flight-adults"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="1"
                                                    max="99"
                                                    className={errors.adults ? 'has-error' : ''}
                                                    placeholder="1"
                                                    value={flight.adults}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '');
                                                        handleFlightChange('adults', val === '' ? '' : parseInt(val, 10));
                                                    }}
                                                />
                                            </div>
                                            {errors.adults && <span className="error-msg">{errors.adults}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-children">Children (2-11 yrs)</label>
                                            <div className="input-wrapper">
                                                <input
                                                    id="flight-children"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="0"
                                                    max="99"
                                                    placeholder="0"
                                                    value={flight.children}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '');
                                                        handleFlightChange('children', val === '' ? '' : parseInt(val, 10));
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-class">Travel Class</label>
                                            <AutosuggestComponent
                                                selectedValue={TRAVEL_CLASS_OPTIONS.find(o => o.value === flight.travelClass) || TRAVEL_CLASS_OPTIONS[0]}
                                                options={TRAVEL_CLASS_OPTIONS}
                                                handleOnChange={(opt) => handleFlightChange('travelClass', opt ? opt.value : 'Economy')}
                                                placeholder="Travel Class"
                                                isSearchable={false}
                                                menuPosition="fixed"
                                                closeButton={false}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Preferred Airline & Remarks */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-airline">Preferred Airline (Optional)</label>
                                            <div className="input-wrapper">
                                                <input
                                                    id="flight-airline"
                                                    type="text"
                                                    placeholder="e.g. IndiGo, Air India, Emirates, Vistara"
                                                    value={flight.preferredAirline}
                                                    onChange={(e) => handleFlightChange('preferredAirline', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="flight-requests">Special Requests / Notes</label>
                                            <div className="input-wrapper">
                                                <textarea
                                                    id="flight-requests"
                                                    rows="2"
                                                    placeholder="e.g. Morning flight preferred, extra luggage, wheelchair assistance"
                                                    value={flight.specialRequests}
                                                    onChange={(e) => handleFlightChange('specialRequests', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : serviceType === 'train' ? (
                            /* TRAIN BOOKING FORM */
                            <div className="section-card">
                                <div className="section-heading">
                                    <div className="section-icon-badge">
                                        <TrainFront size={15} />
                                    </div>
                                    <span>2. Train Journey Details</span>
                                </div>

                                {/* Train Trip Type */}
                                <div className="trip-type-selector">
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${train.tripType === 'oneway' ? 'active' : ''}`}
                                        onClick={() => handleTrainChange('tripType', 'oneway')}
                                    >
                                        🚆 One Way
                                    </button>
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${train.tripType === 'roundtrip' ? 'active' : ''}`}
                                        onClick={() => handleTrainChange('tripType', 'roundtrip')}
                                    >
                                        🔁 Round Trip
                                    </button>
                                </div>

                                {/* From and To */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-from">
                                                From (Station / City) <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <TrainFront className="input-icon" size={15} />
                                                <input
                                                    id="train-from"
                                                    type="text"
                                                    list="popular-train-origins"
                                                    className={`with-icon ${errors.from ? 'has-error' : ''}`}
                                                    placeholder="e.g. Howrah Jn (HWH) or New Delhi (NDLS)"
                                                    value={train.from}
                                                    onChange={(e) => handleTrainChange('from', e.target.value)}
                                                />
                                                <datalist id="popular-train-origins">
                                                    {RAILWAY_STATIONS.map((s, i) => <option key={i} value={s} />)}
                                                </datalist>
                                            </div>
                                            {errors.from && <span className="error-msg">{errors.from}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-to">
                                                To (Station / City) <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <TrainFront className="input-icon" size={15} />
                                                <input
                                                    id="train-to"
                                                    type="text"
                                                    list="popular-train-destinations"
                                                    className={`with-icon ${errors.to ? 'has-error' : ''}`}
                                                    placeholder="e.g. Puri (PURI) or Mumbai CSMT (CSMT)"
                                                    value={train.to}
                                                    onChange={(e) => handleTrainChange('to', e.target.value)}
                                                />
                                                <datalist id="popular-train-destinations">
                                                    {RAILWAY_STATIONS.map((s, i) => <option key={i} value={s} />)}
                                                </datalist>
                                            </div>
                                            {errors.to && <span className="error-msg">{errors.to}</span>}
                                        </div>
                                    </div>
                                </div>

                                {/* Dates */}
                                <div className="row">
                                    <div className={train.tripType === 'roundtrip' ? "col-md-6 col-sm-6" : "col-md-12"}>
                                        <div className="form-group-custom">
                                            <label htmlFor="train-departure-date">
                                                Journey Date <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <Calendar className="input-icon" size={15} />
                                                <input
                                                    id="train-departure-date"
                                                    type="date"
                                                    min={todayStr}
                                                    className={`with-icon ${errors.departureDate ? 'has-error' : ''}`}
                                                    value={train.departureDate}
                                                    onChange={(e) => handleTrainChange('departureDate', e.target.value)}
                                                />
                                            </div>
                                            {errors.departureDate && <span className="error-msg">{errors.departureDate}</span>}
                                        </div>
                                    </div>

                                    {train.tripType === 'roundtrip' && (
                                        <div className="col-md-6 col-sm-6">
                                            <div className="form-group-custom">
                                                <label htmlFor="train-return-date">
                                                    Return Date <span className="required-star">*</span>
                                                </label>
                                                <div className="input-wrapper">
                                                    <Calendar className="input-icon" size={15} />
                                                    <input
                                                        id="train-return-date"
                                                        type="date"
                                                        min={train.departureDate || todayStr}
                                                        className={`with-icon ${errors.returnDate ? 'has-error' : ''}`}
                                                        value={train.returnDate}
                                                        onChange={(e) => handleTrainChange('returnDate', e.target.value)}
                                                    />
                                                </div>
                                                {errors.returnDate && <span className="error-msg">{errors.returnDate}</span>}
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Passengers, Class & Quota */}
                                <div className="row">
                                    <div className="col-md-3 col-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-adults">
                                                Adults (12+ yrs) <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <input
                                                    id="train-adults"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="1"
                                                    max="99"
                                                    className={errors.adults ? 'has-error' : ''}
                                                    placeholder="1"
                                                    value={train.adults}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '');
                                                        handleTrainChange('adults', val === '' ? '' : parseInt(val, 10));
                                                    }}
                                                />
                                            </div>
                                            {errors.adults && <span className="error-msg">{errors.adults}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-children">Children (5-11 yrs)</label>
                                            <div className="input-wrapper">
                                                <input
                                                    id="train-children"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="0"
                                                    max="99"
                                                    placeholder="0"
                                                    value={train.children}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '');
                                                        handleTrainChange('children', val === '' ? '' : parseInt(val, 10));
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-sm-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-class">Travel Class</label>
                                            <AutosuggestComponent
                                                selectedValue={TRAIN_CLASS_OPTIONS.find(o => o.value === train.travelClass) || TRAIN_CLASS_OPTIONS[0]}
                                                options={TRAIN_CLASS_OPTIONS}
                                                handleOnChange={(opt) => handleTrainChange('travelClass', opt ? opt.value : 'All Classes')}
                                                placeholder="Travel Class"
                                                isSearchable={false}
                                                menuPosition="fixed"
                                                closeButton={false}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-sm-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-quota">Quota Preference</label>
                                            <AutosuggestComponent
                                                selectedValue={TRAIN_QUOTA_OPTIONS.find(o => o.value === train.quota) || TRAIN_QUOTA_OPTIONS[0]}
                                                options={TRAIN_QUOTA_OPTIONS}
                                                handleOnChange={(opt) => handleTrainChange('quota', opt ? opt.value : 'General')}
                                                placeholder="Quota"
                                                isSearchable={false}
                                                menuPosition="fixed"
                                                closeButton={false}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Preferred Train & Remarks */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-preferred">Preferred Train / Train No. (Optional)</label>
                                            <div className="input-wrapper">
                                                <input
                                                    id="train-preferred"
                                                    type="text"
                                                    placeholder="e.g. 12301 Rajdhani, 22436 Vande Bharat, Shatabdi"
                                                    value={train.preferredTrain}
                                                    onChange={(e) => handleTrainChange('preferredTrain', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="train-requests">Berth Preference / Notes (Optional)</label>
                                            <div className="input-wrapper">
                                                <textarea
                                                    id="train-requests"
                                                    rows="2"
                                                    placeholder="e.g. Lower berth preference for seniors, side lower, morning arrival"
                                                    value={train.specialRequests}
                                                    onChange={(e) => handleTrainChange('specialRequests', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : serviceType === 'customized_tour' ? (
                            /* CUSTOMIZED TOUR REQUEST FORM */
                            <div className="section-card">
                                <div className="section-heading">
                                    <div className="section-icon-badge">
                                        <Compass size={15} />
                                    </div>
                                    <span>2. Customized Tour Details</span>
                                </div>

                                {/* Destination & Budget */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="tour-destination">
                                                Destination / Places to Visit <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <MapPin className="input-icon" size={15} />
                                                <input
                                                    id="tour-destination"
                                                    type="text"
                                                    className={`with-icon ${errors.destination ? 'has-error' : ''}`}
                                                    placeholder="e.g. Kerala, Ladakh, Europe, Bali"
                                                    value={customTour.destination}
                                                    onChange={(e) => handleCustomTourChange('destination', e.target.value)}
                                                />
                                            </div>
                                            {errors.destination && <span className="error-msg">{errors.destination}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="tour-budget">Approx. Budget (Optional)</label>
                                            <div className="input-wrapper">
                                                <Tag className="input-icon" size={15} />
                                                <input
                                                    id="tour-budget"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="0"
                                                    className="with-icon"
                                                    placeholder="e.g. 80000"
                                                    value={customTour.budget}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => handleCustomTourChange('budget', e.target.value.replace(/\D/g, ''))}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Travel Dates */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="tour-start-date">
                                                Travel Start Date <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <Calendar className="input-icon" size={15} />
                                                <input
                                                    id="tour-start-date"
                                                    type="date"
                                                    min={todayStr}
                                                    className={`with-icon ${errors.startDate ? 'has-error' : ''}`}
                                                    value={customTour.startDate}
                                                    onChange={(e) => handleCustomTourChange('startDate', e.target.value)}
                                                />
                                            </div>
                                            {errors.startDate && <span className="error-msg">{errors.startDate}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="tour-end-date">
                                                Travel End Date <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <Calendar className="input-icon" size={15} />
                                                <input
                                                    id="tour-end-date"
                                                    type="date"
                                                    min={customTour.startDate || todayStr}
                                                    className={`with-icon ${errors.endDate ? 'has-error' : ''}`}
                                                    value={customTour.endDate}
                                                    onChange={(e) => handleCustomTourChange('endDate', e.target.value)}
                                                />
                                            </div>
                                            {errors.endDate && <span className="error-msg">{errors.endDate}</span>}
                                        </div>
                                    </div>
                                </div>

                                {/* Travelers */}
                                <div className="row">
                                    <div className="col-md-6 col-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="tour-adults">
                                                Adults (12+ yrs) <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <Users className="input-icon" size={15} />
                                                <input
                                                    id="tour-adults"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="1"
                                                    max="99"
                                                    className={`with-icon ${errors.adults ? 'has-error' : ''}`}
                                                    placeholder="1"
                                                    value={customTour.adults}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '');
                                                        handleCustomTourChange('adults', val === '' ? '' : parseInt(val, 10));
                                                    }}
                                                />
                                            </div>
                                            {errors.adults && <span className="error-msg">{errors.adults}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="tour-children">Children (2-11 yrs)</label>
                                            <div className="input-wrapper">
                                                <input
                                                    id="tour-children"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="0"
                                                    max="99"
                                                    placeholder="0"
                                                    value={customTour.children}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '');
                                                        handleCustomTourChange('children', val === '' ? '' : parseInt(val, 10));
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Special Requirements */}
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group-custom" style={{ marginBottom: 0 }}>
                                            <label htmlFor="tour-requests">Special Requirements / Notes (Optional)</label>
                                            <div className="input-wrapper">
                                                <textarea
                                                    id="tour-requests"
                                                    rows="2"
                                                    placeholder="e.g. Preferred hotel type, meals, private vehicle, honeymoon setup, wheelchair support"
                                                    value={customTour.specialRequests}
                                                    onChange={(e) => handleCustomTourChange('specialRequests', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            /* CABS BOOKING FORM */
                            <div className="section-card">
                                <div className="section-heading">
                                    <div className="section-icon-badge">
                                        <CarFront size={15} />
                                    </div>
                                    <span>2. Cab & Travel Requirements</span>
                                </div>

                                {/* Cab Trip Type */}
                                <div className="trip-type-selector">
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${cab.tripType === 'outstation_round' ? 'active' : ''}`}
                                        onClick={() => handleCabChange('tripType', 'outstation_round')}
                                    >
                                        🚗 Outstation Round Trip
                                    </button>
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${cab.tripType === 'outstation_oneway' ? 'active' : ''}`}
                                        onClick={() => handleCabChange('tripType', 'outstation_oneway')}
                                    >
                                        ➡️ Outstation One Way
                                    </button>
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${cab.tripType === 'airport_transfer' ? 'active' : ''}`}
                                        onClick={() => handleCabChange('tripType', 'airport_transfer')}
                                    >
                                        ✈️ Airport Transfer
                                    </button>
                                    <button
                                        type="button"
                                        className={`trip-type-pill ${cab.tripType === 'local_rental' ? 'active' : ''}`}
                                        onClick={() => handleCabChange('tripType', 'local_rental')}
                                    >
                                        ⏱️ Local Hourly Rental
                                    </button>
                                </div>

                                {/* Pickup & Drop */}
                                <div className="row">
                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="cab-pickup">
                                                Pickup Location / City <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <MapPin className="input-icon" size={15} />
                                                <input
                                                    id="cab-pickup"
                                                    type="text"
                                                    className={`with-icon ${errors.pickupLocation ? 'has-error' : ''}`}
                                                    placeholder="e.g. Kolkata, Salt Lake or Hotel Address"
                                                    value={cab.pickupLocation}
                                                    onChange={(e) => handleCabChange('pickupLocation', e.target.value)}
                                                />
                                            </div>
                                            {errors.pickupLocation && <span className="error-msg">{errors.pickupLocation}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-6 col-sm-12">
                                        <div className="form-group-custom">
                                            <label htmlFor="cab-drop">
                                                {cab.tripType === 'local_rental'
                                                    ? 'Sightseeing / Coverage Area (Optional)'
                                                    : <>Drop Destination / City <span className="required-star">*</span></>}
                                            </label>
                                            <div className="input-wrapper">
                                                <MapPin className="input-icon" size={15} />
                                                <input
                                                    id="cab-drop"
                                                    type="text"
                                                    className={`with-icon ${errors.dropLocation ? 'has-error' : ''}`}
                                                    placeholder={cab.tripType === 'airport_transfer' ? "e.g. CCU Airport Terminal 2" : "e.g. Digha, Mandarmani, Darjeeling"}
                                                    value={cab.dropLocation}
                                                    onChange={(e) => handleCabChange('dropLocation', e.target.value)}
                                                />
                                            </div>
                                            {errors.dropLocation && <span className="error-msg">{errors.dropLocation}</span>}
                                        </div>
                                    </div>
                                </div>

                                {/* Pickup Date & Time & Return Date */}
                                <div className="row">
                                    <div className="col-md-4 col-sm-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="cab-pickup-date">
                                                Pickup Date <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <Calendar className="input-icon" size={15} />
                                                <input
                                                    id="cab-pickup-date"
                                                    type="date"
                                                    min={todayStr}
                                                    className={`with-icon ${errors.pickupDate ? 'has-error' : ''}`}
                                                    value={cab.pickupDate}
                                                    onChange={(e) => handleCabChange('pickupDate', e.target.value)}
                                                />
                                            </div>
                                            {errors.pickupDate && <span className="error-msg">{errors.pickupDate}</span>}
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-6">
                                        <div className="form-group-custom">
                                            <label htmlFor="cab-pickup-time">
                                                Pickup Time <span className="required-star">*</span>
                                            </label>
                                            <AutosuggestComponent
                                                selectedValue={TIME_SLOT_OPTIONS.find(o => o.value === cab.pickupTime) || { label: cab.pickupTime, value: cab.pickupTime }}
                                                options={TIME_SLOT_OPTIONS}
                                                handleOnChange={(opt) => handleCabChange('pickupTime', opt ? opt.value : '')}
                                                placeholder="Select Time"
                                                isSearchable={true}
                                                menuPosition="fixed"
                                                closeButton={false}
                                            />
                                            {errors.pickupTime && <span className="error-msg">{errors.pickupTime}</span>}
                                        </div>
                                    </div>

                                    {cab.tripType === 'outstation_round' && (
                                        <div className="col-md-4 col-sm-12">
                                            <div className="form-group-custom">
                                                <label htmlFor="cab-return-date">
                                                    Return Date <span className="required-star">*</span>
                                                </label>
                                                <div className="input-wrapper">
                                                    <Calendar className="input-icon" size={15} />
                                                    <input
                                                        id="cab-return-date"
                                                        type="date"
                                                        min={cab.pickupDate || todayStr}
                                                        className={`with-icon ${errors.returnDate ? 'has-error' : ''}`}
                                                        value={cab.returnDate}
                                                        onChange={(e) => handleCabChange('returnDate', e.target.value)}
                                                    />
                                                </div>
                                                {errors.returnDate && <span className="error-msg">{errors.returnDate}</span>}
                                            </div>
                                        </div>
                                    )}

                                    {cab.tripType === 'local_rental' && (
                                        <div className="col-md-4 col-sm-12">
                                            <div className="form-group-custom">
                                                <label htmlFor="cab-rental-package">Rental Duration Package</label>
                                                <AutosuggestComponent
                                                    selectedValue={RENTAL_PACKAGE_OPTIONS.find(o => o.value === cab.rentalPackage) || RENTAL_PACKAGE_OPTIONS[0]}
                                                    options={RENTAL_PACKAGE_OPTIONS}
                                                    handleOnChange={(opt) => handleCabChange('rentalPackage', opt ? opt.value : '')}
                                                    placeholder="Select Package"
                                                    isSearchable={false}
                                                    menuPosition="fixed"
                                                    closeButton={false}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Vehicle Preference & Passengers */}
                                <div className="row">
                                    <div className="col-md-8 col-sm-8">
                                        <div className="form-group-custom">
                                            <label htmlFor="cab-vehicle-type">Preferred Vehicle / Cab Type</label>
                                            <AutosuggestComponent
                                                selectedValue={CAB_TYPE_OPTIONS.find(o => o.value === cab.cabType) || CAB_TYPE_OPTIONS[0]}
                                                options={CAB_TYPE_OPTIONS}
                                                handleOnChange={(opt) => handleCabChange('cabType', opt ? opt.value : '')}
                                                placeholder="Select Vehicle Type"
                                                isSearchable={false}
                                                menuPosition="fixed"
                                                closeButton={false}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-4 col-sm-4">
                                        <div className="form-group-custom">
                                            <label htmlFor="cab-passengers">
                                                Passengers <span className="required-star">*</span>
                                            </label>
                                            <div className="input-wrapper">
                                                <Users className="input-icon" size={15} />
                                                <input
                                                    id="cab-passengers"
                                                    type="number"
                                                    inputMode="numeric"
                                                    min="1"
                                                    max="99"
                                                    className={`with-icon ${errors.passengers ? 'has-error' : ''}`}
                                                    placeholder="1"
                                                    value={cab.passengers}
                                                    onKeyDown={handleNumericKeyDown}
                                                    onPaste={handleNumericPaste}
                                                    onChange={(e) => {
                                                        const val = e.target.value.replace(/\D/g, '');
                                                        handleCabChange('passengers', val === '' ? '' : parseInt(val, 10));
                                                    }}
                                                />
                                            </div>
                                            {errors.passengers && <span className="error-msg">{errors.passengers}</span>}
                                        </div>
                                    </div>
                                </div>

                                {/* Special Requests */}
                                <div className="row">
                                    <div className="col-12">
                                        <div className="form-group-custom" style={{ marginBottom: 0 }}>
                                            <label htmlFor="cab-requests">Special Requests / Instructions (Optional)</label>
                                            <div className="input-wrapper">
                                                <textarea
                                                    id="cab-requests"
                                                    rows="2"
                                                    placeholder="e.g. Carrier for heavy luggage, English/Hindi speaking chauffeur, child car seat, AC throughout the trip"
                                                    value={cab.specialRequests}
                                                    onChange={(e) => handleCabChange('specialRequests', e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Trust highlights */}
                        <div className="trust-highlights">
                            <div className="trust-item">
                                <ShieldCheck className="trust-icon" size={16} />
                                <span>100% Verified Partners</span>
                            </div>
                            <div className="trust-item">
                                <Tag className="trust-icon" size={16} />
                                <span>Guaranteed Best Fares</span>
                            </div>
                            <div className="trust-item">
                                <Zap className="trust-icon" size={16} />
                                <span>Fast Quote in 30 Mins</span>
                            </div>
                        </div>
                    </form>
                )}
            </div>

            {/* Modal Footer */}
            {!isSubmitted && (
                <div className="quotation-modal-footer">
                    <p className="footer-note">
                        <i className="fa fa-shield"></i> Your privacy is protected. No spam guaranteed.
                    </p>

                    <div className="btn-group-actions">
                        <button
                            type="button"
                            className="btn-cancel"
                            onClick={handleResetAndClose}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn-submit-quote"
                            onClick={handleSubmit}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <>
                                    <i className="fa fa-spinner fa-spin"></i> Submitting...
                                </>
                            ) : (
                                <>
                                    <Send size={15} /> Submit Inquiry Request
                                </>
                            )}
                        </button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default QuotationRequestModal;
